export const API_KEY = "AIzaSyCsjCgq06AFh7bhIt87d7LYvLs9rCMf44s";

export default API_KEY;